import React from 'react'
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { BACK_URL, REGISTER_URL, ICDRI2021, ICDRI2022 } from './URLConstants';
import {
    useState, useEffect
} from 'react';

export default function Header() {



    function handleMenuItemClick() {

        const navigation = document.getElementById('tg-navigation');
        if (navigation) {
            navigation.style.display = 'none';
        }

    }

    function handleMenuItemClickNav() {

        const navigation = document.getElementById('tg-navigation');

        if (navigation.style.display === 'none' || navigation.style.display === '') {
            navigation.style.display = 'block';

        } else {
            navigation.style.display = 'none';
        }

    }


    return (
        <>
            <header id="tg-header" className="tg-header">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <strong className="tg-logo"> <Link to='/' ><img src="/images/icdri_logo.png"
                                alt="" /></Link></strong>
                            {/* <input type="text" id="isOp" value={isOpen} /> */}
                            <div className="tg-navigationarea">
                                {/* <a className="tg-btn tg-btnbecommember blinking-button" target="_blank" href={REGISTER_URL}>Register</a>*/}

                                <nav id="tg-nav" className="tg-nav">
                                    <div className="navbar-header">
                                        <button type="button" className="navbar-toggle collapsed" data-toggle="collapse"
                                            data-target="#tg-navigation" aria-expanded="false" onClick={handleMenuItemClickNav}>


                                            <span className="sr-only">Toggle navigation</span>
                                            <span className="icon-bar"></span>
                                            <span className="icon-bar"></span>
                                            <span className="icon-bar"></span>
                                        </button>
                                    </div>


                                    {/* <div id="tg-navigation" className="collapse navbar-collapse tg-navigation"> */}
                                    <div id="tg-navigation" className='collapse navbar-collapse tg-navigation'>



                                        <ul>
                                            <li className="tg-active menu-item-has-children">
                                                <a href="#home" onClick={handleMenuItemClick}>Home</a></li>
                                            <li><a href="#about" onClick={handleMenuItemClick} >About</a></li>
                                            <li><a href="#thematic" onClick={handleMenuItemClick} >Themes</a></li>
                                            <li><a href="#schedule" onClick={handleMenuItemClick}>Schedule</a></li>
                                            <li><a href="#speakers" onClick={handleMenuItemClick}>Speakers</a></li>
                                            <li><a href="#press" onClick={handleMenuItemClick}>Press & News</a></li>
                                            <li><a href="#sub-menu">Past ICDRI</a>
                                                <ul class="sub-menu" id="sub-menu">
                                                    <li>
                                                        <Link to={ICDRI2022} target='_blank' className='icdri-link'>ICDRI 2022</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={ICDRI2021} target='_blank' className='icdri-link'>ICDRI 2021</Link>
                                                    </li>

                                                </ul>
                                            </li>




                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div >
            </header >
        </>
    )
}
